<template>
     <CModal class="" title="Xác nhận" :show.sync="isShowPopup">
      Bạn chắc chắn muốn
      <span v-if="actionType" v-html="actionType.titlePopup()"></span>? <br /><label
        style="font-size:.85em; color:#737373;"
        >
        <span v-if="actionType && actionType.isShowWarningContent" v-html="actionType.warningContentPopup()">
        </span>
        Nhấn
        <span class="text-modal-confirm">Xác nhận</span>
        để thực hiện</label
      >
      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-secondary"
          @click="isShowPopup = false"
        >
          Hủy bỏ
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="submitAction()"
        >
          Xác nhận
        </button>
      </template>
     </CModal>
</template>
<script>
export default {
  components: {},
  props: ["actionTypeMapping"],
  data() {
    var that = this;
    return {
      loading : false,
      isShowPopup: false,
      actionTypeKey: null,
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    }
  },
  methods: {
    submitAction: function() {
      this.isShowPopup = false;
      var that = this;
      var actionType = this.actionType;
      var _successCallback = actionType.successCallback;
      this.$helper.loadDataSource({
        type: actionType.type,
        url: actionType.url,
        isJsonContentType: actionType.isJsonContentType,
        dataSubmit: actionType.dataSubmit || null,
        successCallback: function(response) {
          var data = response.data;
          var data_result = data.data;
          if (!that.$helper.validResponse(that.$router, data)) {
            that.showErrorMsg({ message: data_result });
          } else if(_successCallback){
            _successCallback(data);
          }
        },
        errorCallback: function(error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    setCurrAction: function(key) {
      this.actionTypeKey = key;
    }
  },
  created() {

  },
  mounted() {},
  updated() {

  },
  computed: {
    actionType: function() {
      return this.actionTypeMapping.get(this.actionTypeKey);
    }
  },
  watch: {
   actionTypeKey: function(newValue) {
     if(newValue) {
       this.isShowPopup = true;
     }
   },
   isShowPopup: function(newValue) {
     if(!newValue) {
       this.actionTypeKey = null;
     }
   }
  }
};
</script>
<style scoped></style>
